import React from "react";
import { ShortDateFormat } from "shared/helpers/DateHelpers.js";
import { remittanceHighlightConfig } from "../../../../config/remittanceHighlightConfig";

export const ArchivedDateCell = (props) => {
  const highlightUser = remittanceHighlightConfig.highlightArchivedByUser;
  const shouldHighlight =
    props.dataItem.archivedBy &&
    props.dataItem.archivedBy.toUpperCase() === highlightUser.toUpperCase();

  const textStyle = {
    backgroundColor: shouldHighlight ? "yellow" : "transparent",
    padding: shouldHighlight ? "2px 4px" : "0",
    borderRadius: shouldHighlight ? "3px" : "0",
    display: "inline-block",
  };

  return (
    <td {...props.style}>
      <span style={textStyle}>
        {ShortDateFormat(props.dataItem.archivedDate) || ""}
      </span>
    </td>
  );
};
